import type {Theme} from '@travel-frontend/themes';

import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {
  RATING_SENTIMENT_VERY_DISSATISFIED,
  RATING_SENTIMENT_DISSATISFIED,
  RATING_SENTIMENT_SATISFIED,
  RATING_SENTIMENT_VERY_SATISFIED,
  RATING_SENTIMENT_HIGHLY_SATISFIED,
  type RatingSentiment,
} from '@travel-frontend/ui-components';

const colorTokensBySentiment: Record<RatingSentiment, keyof Theme['colors']> = {
  [RATING_SENTIMENT_VERY_DISSATISFIED]: 'contentAdditionalB',
  [RATING_SENTIMENT_DISSATISFIED]: 'contentAdditionalC',
  [RATING_SENTIMENT_SATISFIED]: 'contentAdditionalE',
  [RATING_SENTIMENT_VERY_SATISFIED]: 'contentAdditionalD',
  [RATING_SENTIMENT_HIGHLY_SATISFIED]: 'systemPositive',
};

type Props = {
  size: 'small' | 'medium';
  sentiment: RatingSentiment;
};

export const RatingBadge = styled.div<Props>(
  ({theme, size, sentiment}) => css`
    ${theme.typography.labelXSmallBold};
    border-radius: 2px;
    color: ${theme.colors.contentInversePrimary};
    background: ${theme.colors[colorTokensBySentiment[sentiment]]};

    ${size === 'small' &&
    css`
      padding: 4px;
    `}

    ${size === 'medium' &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
    `}
  `
);
